import { c as _c } from "react/compiler-runtime";
import { Item, ItemAvatar, ItemAvatarBadge, ItemContent, ItemDescription, ItemSide, ItemTitle } from "@opensea/next-ui-kit";
import { classNames } from "@opensea/ui-kit";
function AccountSwitcherItem(t0) {
  const $ = _c(12);
  let children;
  let className;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = onClick;
    $[4] = rest;
  } else {
    children = $[1];
    className = $[2];
    onClick = $[3];
    rest = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = classNames("h-12 rounded-none border-0 bg-transparent px-3 py-0 hover:rounded-none focus:outline-hidden", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children || $[8] !== onClick || $[9] !== rest || $[10] !== t1) {
    t2 = <Item className={t1} onClick={onClick} {...rest}>{children}</Item>;
    $[7] = children;
    $[8] = onClick;
    $[9] = rest;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
function AccountSwitcherItemAvatarBase(t0) {
  const $ = _c(6);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== rest) {
    t1 = <ItemAvatar rounded={true} {...rest}>{children}</ItemAvatar>;
    $[3] = children;
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function AccountSwitcherItemAvatarBadge(t0) {
  const $ = _c(10);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("p-0", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== rest || $[8] !== t1) {
    t2 = <ItemAvatarBadge {...rest} className={t1}>{children}</ItemAvatarBadge>;
    $[6] = children;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
const AccountSwitcherItemAvatar = AccountSwitcherItemAvatarBase;
export { AccountSwitcherItemAvatarBadge };
function AccountSwitcherItemDescription(t0) {
  const $ = _c(6);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== rest) {
    t1 = <ItemDescription size="xs" {...rest}>{children}</ItemDescription>;
    $[3] = children;
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export { AccountSwitcherItem, AccountSwitcherItemAvatar, ItemContent as AccountSwitcherItemContent, ItemTitle as AccountSwitcherItemTitle, ItemSide as AccountSwitcherItemSide, AccountSwitcherItemDescription };